import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = ['La Guía Maestra "Despertar Sin Dolor" con el paso a paso detallado.', 'El Protocolo LSA de 10 minutos ilustrado para hacer en la cama.', 'La receta del "Agua de Oro": el hidratante anti-oxidante que desinflama tus tejidos.', 'El Plan de Rescate de 21 días para monitorear tu progreso.', 'Checklist de Higiene de Sueño para evitar despertarte "encogido".'];
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <FadeIn data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-black mb-12 text-center text-stone-900" data-id="element-134">
            Lo que obtienes hoy
          </h2>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-stone-200" data-id="element-135">
            <ul className="space-y-6" data-id="element-136">
              {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-137">
                  <li className="flex items-start gap-4" data-id="element-138">
                    <CheckCircle2 className="w-8 h-8 text-amber-600 flex-shrink-0 mt-1" data-id="element-139" />
                    <span className="text-lg md:text-xl text-stone-700 font-medium leading-relaxed" data-id="element-140">
                      {item}
                    </span>
                  </li>
                </FadeIn>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}